import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from '@heroicons/react/24/solid';

interface Experience {
  id: string;
  title: string;
  location: string;
  rating: number;
  price: number;
  imageUrl: string;
  host: string;
}

const experiences: Experience[] = [
  {
    id: '1',
    title: 'Wine Tasting in Bordeaux',
    location: 'Bordeaux, France',
    rating: 4.98,
    price: 65,
    imageUrl: 'https://picsum.photos/400/300?random=1',
    host: 'Marie'
  },
  {
    id: '2',
    title: 'Cooking Class with Local Chef',
    location: 'Barcelona, Spain',
    rating: 4.95,
    price: 89,
    imageUrl: 'https://picsum.photos/400/300?random=2',
    host: 'Carlos'
  },
  // Add more experiences as needed
];

const ExperiencesPage: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  return (
    <div className="min-h-screen bg-white">
      <main>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-6 py-6 overflow-x-auto scrollbar-hide">
            {['All', 'Cooking', 'Art', 'History', 'Music', 'Nature', 'Sports'].map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category.toLowerCase())}
                className={`px-4 py-2 text-sm font-medium rounded-full whitespace-nowrap transition-colors ${
                  selectedCategory === category.toLowerCase()
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="mt-8">
            <h1 className="text-2xl font-semibold text-gray-900">
              Popular experiences around the world
            </h1>
            <p className="mt-1 text-sm text-gray-500">
              Book activities led by local hosts on your next trip
            </p>
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {experiences.map((experience) => (
              <motion.div
                key={experience.id}
                className="group cursor-pointer"
                whileHover={{ y: -4 }}
                transition={{ duration: 0.2 }}
              >
                <div className="relative aspect-square overflow-hidden rounded-xl">
                  <img
                    src={experience.imageUrl}
                    alt={experience.title}
                    className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="mt-3">
                  <div className="flex items-center gap-1">
                    <StarIcon className="h-4 w-4 text-airbnb-red" />
                    <span className="text-sm font-medium">{experience.rating}</span>
                  </div>
                  <h3 className="mt-2 text-base font-medium text-gray-900">
                    {experience.title}
                  </h3>
                  <p className="mt-1 text-sm text-gray-500">
                    From ${experience.price} per person
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default ExperiencesPage;